import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../../../utils/hooks/useMutationWithError";
import {
  UserContactStatus,
  useCheckUserPhoneStatusMutation,
} from "./__generated__/useCheckUserPhoneStatusMutation.graphql";

export const useCheckUserPhoneStatus = () => {
  const [checkStatus, isChecking] =
    useMutationWithError<useCheckUserPhoneStatusMutation>(
      userCheckPhoneMutationString
    );

  const checkPhone = (
    phoneNumber: string,
    onCompleteHandler: (
      value: string,
      result: UserContactStatus,
      type: "Phone"
    ) => void
  ) => {
    checkStatus({
      variables: { input: { phoneNumber } },
      onCompleted: (res) => {
        if (res.responsePayload?.success && res.responsePayload.result) {
          onCompleteHandler(phoneNumber, res.responsePayload.result, "Phone");
        }
      },
    });
  };
  return [checkPhone, isChecking] as const;
};

export const userCheckPhoneMutationString = graphql`
  mutation useCheckUserPhoneStatusMutation($input: UserPhoneStatusInput!) {
    responsePayload: userPhoneStatus(input: $input) {
      success
      result
      errors {
        field
        code
        message: code
      }
    }
  }
`;
